import React from 'react';
import Spinner from '../../../Spinner';
import OptionsList from './OptionsList';
import { useSelect } from '../hooks/useCoreContext';
import type { CheckboxShape } from '@frekuent/orbit/components';

type PanelProps = React.HTMLAttributes<HTMLDivElement> & {
	checkBoxShape?: CheckboxShape;
	showSelectAll?: boolean;
	isLoadingOptions?: boolean;
	children?: React.ReactNode;
	showScrollbar?: boolean;
};

const Panel = ({
	checkBoxShape,
	isLoadingOptions = false,
	children,
	showScrollbar = true,
	...rest
}: PanelProps) => {
	const { ids } = useSelect();

	return (
		<div
			id={ids.listbox}
			role='listbox'
			aria-labelledby={ids.label}
			tabIndex={-1}
			{...rest}
		>
			{isLoadingOptions ? (
				<div className='space-y-4'>
					<Spinner />
				</div>
			) : (
				children || (
					<OptionsList
						checkBoxShape={checkBoxShape}
						showScrollbar={showScrollbar}
					/>
				)
			)}
		</div>
	);
};

export default Panel;
